export default __webpack_public_path__ + "static/1-7472ea71c1735d855c0f3ddcca12b76b.png";